'use client';
import Image from 'next/image';
import styles from './Header.module.scss';
import ImageBack from '@/public/assets/Images/HeaderImageBack.svg';
import ImageFront from '@/public/assets/Images/HeaderImageFront.svg';
import HeaderImageBackEng from '@/public/assets/Images/HeaderImageBackEng.svg';
import HeaderImageFrontEng from '@/public/assets/Images/HeaderImageFrontEng.svg';
import ImageBGPattern from '@/public/assets/Images/BGPattern.svg';
import { IconMessage2 } from '@/public/assets/icons/IconMessage2';
import { HeaderMenu } from '../HeaderMenu';
import { useLocale, useTranslations } from 'next-intl';
import Link from 'next/link';
import { useState } from 'react';
import { FeedbackForm } from '../FeedbackForm';
import { trackEvent } from '@/shared/components/GoogleMetrika/GoogleMetrika';

export const Header = () => {
  const t = useTranslations('header');
  const locale = useLocale();
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);

  const isOnlyEng = process.env.NEXT_PUBLIC_IS_ONLY_EN === 'True';

  const logoBack = locale === 'en' ? HeaderImageBackEng : ImageBack;
  const logoFront = locale === 'en' ? HeaderImageFrontEng : ImageFront;

  const handleOpenFeedback = () => {
    trackEvent('button_click', {
      button_name: 'contact_from_button',
      page: window.location.pathname,
    });
    setFeedbackOpen(true);
  };

  return (
    <header className={styles.header}>
      <HeaderMenu />
      <section className={styles.headerContent}>
        <div className={styles.headerContentTitle}>
          <div className={styles.headerContentTitleText}>
            <div className={styles.headerContentTitleTextMain}>
              <h1>{t('company')}</h1>
              <h2>{t('title')}</h2>
              <h3>{t('titleRow')}</h3>
            </div>
            <h4>{t('subtitle')}</h4>
          </div>
          {/* <Link href={`/${locale}/demo`} legacyBehavior>
            <button
              className={`${styles.button} ${styles.headerContentButton}`}
            >
              {t('more')}
            </button>
          </Link> */}
          {!isOnlyEng && 
            <Link 
              href={'https://reestr.digital.gov.ru/reestr/8094081/'} 
              target="_blank"
              className={styles.reestr}
            >
              {t("reestr")}
            </Link>
          }
        </div>
        <div
          className={
            locale === 'en'
              ? styles.headerContentImagesEn
              : styles.headerContentImages
          }
        >
          <figure>
            <Image src={logoBack} alt="header back" width={535} height={342} />
          </figure>
          <figure>
            <Image
              src={logoFront}
              alt="header front"
              width={535}
              height={342}
            />
          </figure>
        </div>
      </section>

      <div className={styles.BGPattern}>
        <figure>
          <Image
            src={ImageBGPattern}
            alt="header background image grid"
            width={1400}
            height={769}
          />
        </figure>
      </div>

      <div className={styles.iconMessage} onClick={handleOpenFeedback}>
        <IconMessage2 />
      </div>
      <FeedbackForm
        isOpen={isFeedbackOpen}
        onClose={() => setFeedbackOpen(false)}
      />
    </header>
  );
};
